<template>
	<div id="systemmodule">
		<HrrBreadcrumb PMname="设备指令与日志" CMname="指令管理功能" />
		<HrrMainLayout>
			<template slot="searh">
				<el-form :inline="true" :model="searchform">
					<el-form-item >
						<el-input v-model="keyword" placeholder="关键字" >
							<el-select v-model="selectfield" slot="prepend" placeholder="请选择" class="input-with-select">
						      <el-option label="设备编号" value="deviceCode"></el-option>
                              <el-option label="指令操作" value="orderContent"></el-option>
                              <el-option label="上传人" value="creationBy"></el-option>
						    </el-select>
						</el-input>
					</el-form-item>
					<el-form-item label="上传时间：">
                        <el-date-picker v-model="searchform.startTime" placeholder="开始时间" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="至">
                        <el-date-picker v-model="searchform.endTime" placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="审核状态：" prop="isPass">
                        <el-select v-model="searchform.isPass" placeholder="请选择" >
                            <el-option label="全部" value=""></el-option>
                             <el-option label="待审核" :value="0"></el-option>
                            <el-option label="已审核" :value="1"></el-option>
							<el-option label="已驳回" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="发送状态：" prop="isSend">
                        <el-select v-model="searchform.isSend" placeholder="请选择" >
                            <el-option label="全部" value=""></el-option>
                             <el-option label="待发送" :value="0"></el-option>
                            <el-option label="已发送" :value="1"></el-option>
                        </el-select>
                    </el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit">查询</el-button>
					</el-form-item>
				</el-form>
			</template>
			<template slot="buttons">
				<el-button-group>
					<el-button type="primary" icon="el-icon-edit-outline" size="small" @click="rejectClick" v-if="isHadFun('examine')">批量驳回</el-button>
					<el-button type="primary" icon="el-icon-edit" size="small" @click="passClick" v-if="isHadFun('examine')">批量审核</el-button>
					<el-button type="primary" icon="el-icon-edit-outline" size="small" @click="sendClick" v-if="isHadFun('send')">批量发送</el-button>
					<el-button type="primary" icon="el-icon-delete" size="small" @click="delclick" v-if="false">批量删除</el-button>
					<el-button type="primary" icon="fa fa-check-square-o" size="small" v-if="false">审核</el-button>
				</el-button-group>
			</template>
			<template slot="table">
				<el-table  :data="tableData" ref="Opentable"  @selection-change="selectionchange"
				border 
				stripe 
				style="width: 100%" 
				v-loading="loading"  >
				<el-table-column type="selection" width="55" fixed="left" :selectable="selectable">
				</el-table-column>
				<el-table-column  type="index" label="序号" width="60" fixed="left" >
				</el-table-column>
				<el-table-column prop="siteName" label="所属站点" width="150" fixed="left">
                </el-table-column>
                <el-table-column prop="lightBoxCode" label="媒体编号" width="120" fixed="left">
                </el-table-column>
				<el-table-column prop="deviceNickCode" label="设备编号" width="160" fixed="left" sortable >
				</el-table-column>
				<el-table-column prop="deviceCode" label="自动设备编号" width="160" fixed="left" v-if="isHadFun('deviceCode')">
				</el-table-column>
				<el-table-column prop="orderContent" label="指令操作" >
				</el-table-column>
				<el-table-column prop="content" label="指令内容" width="400">
				</el-table-column>
				<el-table-column prop="creationDate" label="上传时间" width="160" sortable>
				</el-table-column>
				<el-table-column prop="creationBy" label="上传人" width="90" >
				</el-table-column>
				<el-table-column label="审核状态" width="100" align="center" fixed="right" >
                    <template slot-scope="scope">
                        <el-tag  type="warning" disable-transitions v-if="scope.row.isPass==0" >待审核</el-tag>
                        <el-tag  type="success" disable-transitions v-if="scope.row.isPass==1" >已审核</el-tag>
						<el-tag  type="danger" disable-transitions v-if="scope.row.isPass==2" >已驳回</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="发送状态" width="100" align="center" fixed="right" >
                    <template slot-scope="scope">
                        <el-tag  type="warning" disable-transitions v-if="scope.row.isSend==0" >待发送</el-tag>
                        <el-tag  type="success" disable-transitions v-if="scope.row.isSend==1" >已发送</el-tag>
						<el-tag  type="success" disable-transitions v-if="scope.row.isSend==2" >已驳回</el-tag>
                    </template>
                </el-table-column>
				<el-table-column label="操作" width="140" fixed="right">
					<template slot-scope="scope">
						<el-button @click.stop="RowReject(scope.row)" type="text" size="small" v-if="isHadFun('examine') && scope.row.isPass==0" >驳回请求</el-button>
						<el-button @click.stop="RowPass(scope.row)" type="text" size="small" v-if="isHadFun('examine') && scope.row.isPass==0" >审核</el-button>
						<el-button @click.stop="RowSend(scope.row)" type="text"  size="small" v-if="isHadFun('send') && scope.row.isSend==0 && scope.row.isPass==1" >发送</el-button>
					</template>
				</el-table-column>
			</el-table>
		</template>
		<template slot="Pagination">
			<el-pagination
			background
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page="searchform.pageNum"
			:page-sizes="[5, 10, 15,50]"
			layout="total, sizes, prev, pager, next, jumper"
			:total="total">
		</el-pagination>
	</template>
</HrrMainLayout>
</div>
</template>
<script>
	export default {
		name: 'device_orderTemp',
		data(){
			return{
				searchform:{
					pageNum:1,
					pageSize:10,
					siteType:1,
					orderContent:"",
					creationBy:"",
					deviceCode:"",
					isPass:"",
					isSend:"",
					startTime:"",
					endTime:""
				},
				tableData:[],
				total:0,
				loading:true,
				selectionRows:[],
				selectfield:"deviceCode",
				keyword:"",
				dialogVisible:false,
				checkExamineType:false
			}
		},
		methods:{
			onSubmit(){
				this.searchform.deviceCode="";
				this.searchform.creationBy="";
				this.searchform.orderContent="";
				this.searchform.pageNum=1;
				this.searchform[this.selectfield]=this.keyword.trim();
				this.$route.meta.orderTemp=this.searchform;
				this.initData();
			},
			handleSizeChange(val) {
				this.searchform.pageSize=val;
				this.initData();
			},
			handleCurrentChange(val) {
				this.searchform.pageNum=val;
				this.initData();
			},
			RowReject(val){

				this.$confirm("确定要驳回 设备号：'"+val.deviceNickCode+"' ，指令操作："+val.orderContent+"' 此记录么？","驳回提示",{type:"warning"})
				.then(()=>{
					var Vuethis=this;
					this.$hrraxios({
                        method: "GET",
                        url:this.$api.OrderTemp.reject+"/"+val.tOrderId})
					.then((response)=>{
						var redata=response.data;
						if(redata.Success==true){
							Vuethis.$message({message:"驳回成功！",type:"success"});
							Vuethis.initData();
						}else{
							Vuethis.$message({message:redata.Prompt,type:"error"});
						}
					})
				}).catch((error)=>{
					console.log(error);
				});
			},
			RowPass(val){

				this.$confirm("确定要审核 设备号：'"+val.deviceNickCode+"' ，指令操作："+val.orderContent+"' 此记录么？","审核提示",{type:"warning"})
				.then(()=>{
					var Vuethis=this;
					this.$hrraxios({
                        method: "GET",
                        url:this.$api.OrderTemp.pass+"/"+val.tOrderId})
					.then((response)=>{
						var redata=response.data;
						if(redata.Success==true){
							Vuethis.$message({message:"审核成功！",type:"success"});
							Vuethis.initData();
						}else{
							Vuethis.$message({message:redata.Prompt,type:"error"});
						}
					})
				}).catch((error)=>{
					console.log(error);
				});
			},
			RowSend(val){

				this.$confirm("确定要发送 设备号：'"+val.deviceNickCode+"' ，指令操作："+val.orderContent+"'  此记录么？","发送提示",{type:"warning"})
				.then(()=>{
					var Vuethis=this;
					this.$hrraxios({
                        method: "GET",
                        url:this.$api.OrderTemp.send+"/"+val.tOrderId})
					.then((response)=>{
						var redata=response.data;
						if(redata.Success==true){
							Vuethis.$message({message:"发送成功！",type:"success"});
							Vuethis.initData();
						}else{
							Vuethis.$message({message:redata.Prompt,type:"error"});
						}
					})
				}).catch((error)=>{
					console.log(error);
				});;
			},
			Rowdelete(val){

				this.$confirm("确定要删除 '"+val.deviceNickCode+"' 此记录么？","删除提示",{type:"warning"})
				.then(()=>{
					var Vuethis=this;
					this.$hrraxios({
                        method: "delete",
                        url:this.$api.site.DelSite+"/"+val.tOrderId})
					.then((response)=>{
						var redata=response.data;
						if(redata.Success==true){
							Vuethis.$message({message:"删除成功！",type:"success"});
							Vuethis.initData();
						}else{
							Vuethis.$message({message:redata.Prompt,type:"error"});
						}
					})
				}).catch((error)=>{
					console.log(error);
				});
			},
			RowPublic(val){

			},
			rejectClick(){
				for(var i=0;i<this.selectionRows.length;i++){
					if(this.selectionRows[i].isPass==1){
						this.$message({message:"选择有已审核的记录，请取消选择已审核记录",type:"warning"});
						return;
					}
				}
				if(this.selectionRows.length<1)
				{
					this.$message({message:"请先选择一行再驳回",type:"warning"});
					return;
				}
				this.$confirm("确定要驳回这些记录么？",{type:"warning"})
				.then(()=>{
					var loading = this.$loading({
						lock: true,
						text: '驳回中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					var Vuethis=this;
					var PostfunArr=[];
					this.selectionRows.forEach(myrow=>{
						var postRe=this.$hrraxios({
                        method: "GET",
						url:this.$api.OrderTemp.reject+"/"+myrow.tOrderId})
						PostfunArr.push(postRe);
					});
					this.$axios.all(PostfunArr)
					.then(this.$axios.spread(function(){
						loading.close();
						//console.log(arguments);
						var isalldel=true;
						for(var i=0;i<arguments.length;i++){
							if(arguments[i].data.Success==false)
							{
								isalldel=false;
							}
						}
						if(isalldel==true){
							Vuethis.$message({message:"全部审核成功！",type:"success"});
							Vuethis.initData();
						}else{
							//有审核失败的未处理
						}
					}));
				})
				.catch((error)=>{
					
				});
			},
			passClick(){
				for(var i=0;i<this.selectionRows.length;i++){
					if(this.selectionRows[i].isPass==1){
						this.$message({message:"选择有已审核的记录，请发送已审核记录",type:"warning"});
						return;
					}
				}
				if(this.selectionRows.length<1)
				{
					this.$message({message:"请先选择一行在审核",type:"warning"});
					return;
				}
				this.$confirm("确定要审核这些记录么？",{type:"warning"})
				.then(()=>{
					var loading = this.$loading({
						lock: true,
						text: '审核中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					var Vuethis=this;
					var PostfunArr=[];
					this.selectionRows.forEach(myrow=>{
						var postRe=this.$hrraxios({
                        method: "GET",
                        url:this.$api.OrderTemp.pass+"/"+myrow.tOrderId})
						PostfunArr.push(postRe);
					});
					this.$axios.all(PostfunArr)
					.then(this.$axios.spread(function(){
						loading.close();
						//console.log(arguments);
						var isalldel=true;
						for(var i=0;i<arguments.length;i++){
							if(arguments[i].data.Success==false)
							{
								isalldel=false;
							}
						}
						if(isalldel==true){
							Vuethis.$message({message:"全部审核成功！",type:"success"});
							Vuethis.initData();
						}else{
							//有审核失败的未处理
						}
					}));
				})
				.catch((error)=>{
					
				});
			},
			handleClick(tab, event) {
                console.log(tab, event);
            },
			pubclick(){
				if(this.selectionRows.length==0)
				{
					this.$message({message:"请先选择一行在操作",type:"warning"});
					return;
				}

			},
			sendClick(){
				for(var i=0;i<this.selectionRows.length;i++){
					if(this.selectionRows[i].isPass==0){
						this.$message({message:"选择有未审核记录，请先审核再发送",type:"warning"});
						return;
					}
				}
				if(this.selectionRows.length<1)
				{
					this.$message({message:"请先选择一行在发送",type:"warning"});
					return;
				}
				this.$confirm("确定要发送这些记录么？",{type:"warning"})
				.then(()=>{
					var loading = this.$loading({
						lock: true,
						text: '发送中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					var Vuethis=this;
					var PostfunArr=[];
					this.selectionRows.forEach(myrow=>{
						var postRe=this.$hrraxios({
                        method: "GET",
                        url:this.$api.OrderTemp.send+"/"+myrow.tOrderId})
						PostfunArr.push(postRe);
					});
					this.$axios.all(PostfunArr)
					.then(this.$axios.spread(function(){
						loading.close();
						//console.log(arguments);
						var isalldel=true;
						for(var i=0;i<arguments.length;i++){
							if(arguments[i].data.Success==false)
							{
								isalldel=false;
							}
						}
						if(isalldel==true){
							Vuethis.$message({message:"全部发送成功！",type:"success"});
							Vuethis.initData();
						}else{
							//有删除失败的未处理
						}
					}));
				})
				.catch((error)=>{
					
				});
			},
			delclick(){
				if(this.selectionRows.length<1)
				{
					this.$message({message:"请先选择一行在删除",type:"warning"});
					return;
				}
				this.$confirm("确定要删除这些记录么？",{type:"warning"})
				.then(()=>{
					var loading = this.$loading({
						lock: true,
						text: '删除中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					var Vuethis=this;
					var PostfunArr=[];
					this.selectionRows.forEach(myrow=>{
						var postRe=this.$hrraxios({
                        method: "delete",
                        url:this.$api.site.DelSite+"/"+myrow.siteId})
						PostfunArr.push(postRe);
					});
					this.$axios.all(PostfunArr)
					.then(this.$axios.spread(function(){
						loading.close();
						//console.log(arguments);
						var isalldel=true;
						for(var i=0;i<arguments.length;i++){
							if(arguments[i].data.Success==false)
							{
								isalldel=false;
							}
						}
						if(isalldel==true){
							Vuethis.$message({message:"全部删除成功！",type:"success"});
							Vuethis.initData();
						}else{
							//有删除失败的未处理
						}
					}));
				})
				.catch((error)=>{
					
				});
			},
			selectionchange(selection){
				this.selectionRows=selection;
			},
			selectable (row, index) {
            return ((row.isPass == 0||row.isPass == 1) && row.isSend==0)// isHidden 0-否 1-是 返回false不可选
        	},
			initData(){
				var Vuethis=this;
				this.loading=true;
				//this.$hrraxios.get(this.$api.device.getdeviceList, {params:this.searchform})
				this.$hrraxios.get(this.$api.OrderTemp.api, {params:this.searchform})
				.then(function (response) {
					Vuethis.loading=false;
					var data=response.data;
					if(data.Success==true)
					{
						Vuethis.tableData=data.Data.List;
						Vuethis.total=data.Data.Total;
						for(var i=0;i<Vuethis.tableData.length;i++){
								if(Vuethis.tableData[i].isPass==2){
								Vuethis.checkExamineType=true
							}
						}
					}else{
						Vuethis.$message.error(data.Prompt);
					}
				})
				.catch(function (error) {
					Vuethis.loading=false;
					console.log(error);
				});
			},
			initParamsData(){
				//this.$common.getplanlist(this,"planIdData");
				//this.$common.getFunListByMCode(this,"PlanOpen");
				var now = new Date();
	            now = now.setDate(now.getDate() - 1);
	            now = new Date(now);
	            this.searchform.startTime = now;
			}
		},
		beforeRouteLeave(to, from, next) {
			// 导航离开该组件的对应路由时调用
			to.meta.row=from.meta.row;
			to.meta.orderTemp=from.meta.orderTemp;
			next();
		},
		created(){
			this.$common.getFunListByMCode(this,"DeviceOrderTemp",()=>{
				this.initData();
				this.initParamsData();
			});
		}
	}
</script>
<style >
  .input-with-select { width: 110px;}
	.educard label {color: #99a9bf;}
	.educard{margin-bottom: 10px;}
	.utable .el-button,.utable .el-button+.el-button{margin-right: 10px;margin-left: 0;}
  #lightForm .el-select{width: 100px;}
</style>
